import React, { useState, useEffect } from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import CustomTable from "../../organisms/CustomTable";
import Input from "../../atoms/Input";
import CustomDate from "../../atoms/CustomDate";
import { useForm } from "react-hook-form";
import { retirePopupPost } from "../../../utils/API/retirePopupPost";
import { useDispatch } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import { orderPayment } from "../../../utils/API/orderPayment";

const RetireDailogBox = ({
  open,
  onCancel,
  onOk,
  selectedRowData,
  selectedColumns,
  payment = false,
  transactionId,
  typeOfCredit,
  couponCode = ""
}) => {
  const dispatch = useDispatch();
  const { register } = useForm();
  useEffect(() => {}, [selectedRowData, selectedColumns]);

  let bodyData;
  let headerData;

  if (selectedRowData && selectedColumns) {
    bodyData = [selectedColumns.map((column) => selectedRowData[column])];
    headerData = selectedColumns;
  }

  const [numberOfCreditsRetire, setNumberOfCreditsRetire] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [goal, setGoal] = useState("");
  const [isStartDate, setStartDate] = useState(null);
  const [isEndDate, setEndDate] = useState(null);
  const [numberofCreditsError, setNumberOfCreditsError] = useState("");
  const [organizationError, setOrganizationError] = useState("");
  const [goalError, setGoalError] = useState("");
  const [dateError, setDateError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleRetirePopUpOk = async () => {
    const projectId = selectedRowData["Project Id"];
    const noOfCreditsRetire = payment
      ? selectedRowData["Number Of Credits"]
      : numberOfCreditsRetire;

    const retireFormData = {
      project_id: projectId,
      no_of_credits: noOfCreditsRetire,
      nameOfBeneficiaryOrg: organizationName,
      goal: goal,
      timePeriod: {
        start_time: isStartDate,
        end_time: isEndDate
      }
    };

    if (!noOfCreditsRetire) {
      setNumberOfCreditsError("Please Enter Number of credits");
      return;
    }

    if (!organizationName) {
      setOrganizationError("Please enter Organization Name");
      return;
    }

    if (!goal) {
      setGoalError("Please enter Goal");
      return;
    }

    if (!isStartDate || !isEndDate) {
      setDateError("Please select Start and End Dates");
      return;
    }
    // console.log(payment);

    if (payment === true) {
      try {
        setLoading(true);
        const payment = await orderPayment({
          transactionId,
          formData: { couponCode, retirementData: retireFormData },
          dispatch
        });
        if (payment) {
          onOk();
        }
      } catch (error) {
        toast.error("Error while doing Payment", error);
      } finally {
        setLoading(false);
      }
    }

    if (payment === false) {
      try {
        setLoading(true);
        await retirePopupPost(retireFormData, dispatch);
        onOk();
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };

  const title = "Time Period";
  const startDate = "From";
  const endDate = "To";

  return (
    <div>
      <DiaglogBox open={open} onCancel={onCancel} width={707}>
        <div className="pt-5">
          <div>
            <CustomTable data={bodyData} headerData={headerData} />
          </div>
          <div className="px-8 pt-3">
            <div className="pb-2">
              <label className="text-lg font-bold">
                No. of Credits to Retire
              </label>
              {!payment && (
                <Input
                  type="number"
                  variant="secondary"
                  className="inline-block w-28 pl-5"
                  value={numberOfCreditsRetire}
                  onChange={(e) => {
                    const enteredValue = parseInt(e.target.value, 10);
                    const maxCredits = selectedRowData["Number Of Credits"];
                    setNumberOfCreditsError("");
                    if (enteredValue > 0) {
                      setNumberOfCreditsRetire(
                        Math.min(maxCredits, enteredValue)
                      );
                    } else {
                      setNumberOfCreditsRetire(null);
                    }
                    // if (enteredValue <= maxCredits && enteredValue) {
                    //   setNumberOfCreditsRetire(enteredValue);
                    // } else {
                    //   setNumberOfCreditsRetire(maxCredits);
                    // }
                  }}
                />
              )}
              {payment && (
                <Input
                  type="number"
                  variant="secondary"
                  className="inline-block w-28 pl-5"
                  value={
                    selectedRowData ? selectedRowData["Number Of Credits"] : ""
                  }
                  disabled={true}
                />
              )}
            </div>
            <p className="text-sm text-red-700">{numberofCreditsError}</p>
            <h4 className="font-medium text-black text-base pt-2">
              Please Provide the following details to retire the credits
            </h4>
            <Input
              className="pt-3 text-xs"
              label="Name of the Beneficiary Organization"
              type="text"
              variant="primary"
              value={organizationName}
              onChange={(e) => {
                setOrganizationName(e.target.value);
                setOrganizationError("");
              }}
            />
            <p className="text-sm text-red-700">{organizationError}</p>
            <Input
              label="Goal"
              type="text"
              className="pt-3 text-xs"
              variant="primary"
              value={goal}
              onChange={(e) => {
                setGoal(e.target.value);
                setGoalError("");
              }}
            />
            <p className="text-sm text-red-700">{goalError}</p>
            <div className="pt-6">
              <label className="text-xs  text-gray-400">Time Period</label>

              <CustomDate
                title={title}
                labelRequired={false}
                stateName={{
                  startDate: "start_date",
                  endDate: "end_date"
                }}
                register={register}
                startDateLabel={startDate}
                endDateLabel={endDate}
                onStartDateChange={(date) => {
                  setStartDate(date);
                  setDateError("");
                }}
                onEndDateChange={(date) => {
                  setEndDate(date);
                  setDateError("");
                }}
              />
              <p className="text-sm text-red-700">{dateError}</p>
            </div>
          </div>
          <div className="flex justify-center gap-x-2 pt-4">
            <Button
              varient="primary"
              color="blue"
              className="w-52 h-14 text-base mb-6 py-2 text-white font-bold"
              onClick={handleRetirePopUpOk}
              disabled={loading}
            >
              {loading ? (
                <div className="flex items-center ml-4 justify-center gap-2">
                  {payment ? (
                    <span className="ml-2">Retire & Pay</span>
                  ) : (
                    <span className="ml-2">Retire</span>
                  )}
                  <div>
                    <LoadingOutlined className="ml-2" />
                  </div>
                </div>
              ) : payment ? (
                "Retire & Pay"
              ) : (
                "Retire"
              )}
            </Button>

            <Button
              varient="primary"
              borderColor={"blue"}
              color="white"
              onClick={onCancel}
              className="w-52 h-14 text-base mb-6 text-blue-800 font-bold border-[1px]"
            >
              Cancel
            </Button>
          </div>
        </div>
      </DiaglogBox>
    </div>
  );
};

export default RetireDailogBox;
